// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header-wrapper {
    height: auto;
    padding: 2em 5em;
    border-bottom: 5px solid #333333;
}



.divider {
    border-right: 3px solid #333333;
    /* height: 100px; */
    /* width: 80px; */
    height: 50px;
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
}



@media only screen and (max-width: 500px) {
    .store-header {
        font-size: 15px;
        font-family: monospace;
        cursor: pointer;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        height: 50px;
        padding: 10px;
    }
}
@media only screen and (min-width: 501px) {
    .store-header {
        font-size: 40px;
        font-family: monospace;
        cursor: pointer;
        border-top: 3px solid black;
        border-bottom: 3px solid black;
        height: 50px;
        padding: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/client/Components/MainHeader/mainHeader.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;AACpC;;;;AAIA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;AACtB;;;;AAIA;IACI;QACI,eAAe;QACf,sBAAsB;QACtB,eAAe;QACf,2BAA2B;QAC3B,8BAA8B;QAC9B,YAAY;QACZ,aAAa;IACjB;AACJ;AACA;IACI;QACI,eAAe;QACf,sBAAsB;QACtB,eAAe;QACf,2BAA2B;QAC3B,8BAA8B;QAC9B,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".main-header-wrapper {\n    height: auto;\n    padding: 2em 5em;\n    border-bottom: 5px solid #333333;\n}\n\n\n\n.divider {\n    border-right: 3px solid #333333;\n    /* height: 100px; */\n    /* width: 80px; */\n    height: 50px;\n    display: inline-block;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n\n\n@media only screen and (max-width: 500px) {\n    .store-header {\n        font-size: 15px;\n        font-family: monospace;\n        cursor: pointer;\n        border-top: 3px solid black;\n        border-bottom: 3px solid black;\n        height: 50px;\n        padding: 10px;\n    }\n}\n@media only screen and (min-width: 501px) {\n    .store-header {\n        font-size: 40px;\n        font-family: monospace;\n        cursor: pointer;\n        border-top: 3px solid black;\n        border-bottom: 3px solid black;\n        height: 50px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
